export type CompanyReportingMethod = 'API' | 'MAIL' | 'SHARED_FOLDER';

export interface ICompanyConfigRequest {
  companyId: number;
  reportingMethod: CompanyReportingMethod;
  mailUrl?: string;
  sharedFolderUrl?: string;
  apiUrl?: string;
  apiKey?: string;
  apiUsername?: string;
  apiPassword?: string;
} 